import React, { FC } from 'react';

import { Button, Badge } from '@mui/material';
import { Sliders } from 'react-feather';
import { useFilteredSearchResults } from '../providers/FilteredSearchResultsProvider';

interface SearchFiltersButtonProps {
  setFiltersDialogOpen: (open: boolean) => void;
}

export const SearchFiltersButton: FC<SearchFiltersButtonProps> = ({
  setFiltersDialogOpen,
}) => {
  const { getActiveFilterCount } = useFilteredSearchResults();

  const activeFilterCount = getActiveFilterCount();

  return (
    <Button
      variant="outlined"
      startIcon={<Sliders size={18} />}
      onClick={() => setFiltersDialogOpen(true)}
      sx={{
        borderRadius: '500px',
        color: 'text.primary',
        px: 3,
        py: 1,
        minWidth: 'auto',
        position: 'relative',
      }}
    >
      Filters
      {activeFilterCount > 0 && (
        <Badge
          badgeContent={activeFilterCount}
          color="primary"
          sx={{
            position: 'absolute',
            top: 6,
            right: 4,
          }}
        />
      )}
    </Button>
  );
};
